
var app = angular.module('directives.inputfield', []);

require('./directives/inputfield.js');
require('./templates/field.html');
// require('./stylesheets/index.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/inputfield/index.js
 ** module id = 167
 ** module chunks = 1
 **/